import { useCallback, useRef, useState } from 'react';
import useEventListener from 'hooks/elements/useEventListener';

const useElementDimensions = <T extends HTMLElement = HTMLDivElement>() => {
  const ref = useRef<T | null>(null);
  const [size, setSize] = useState<DOMRect | null>(null);

  const refresh = useCallback(() => {
    const domRect = ref.current?.getBoundingClientRect();

    if (domRect) {
      setSize(domRect);
    }
  }, []);

  useEventListener('resize', refresh);
  useEventListener('scroll', refresh, true);

  return { size, ref, refresh };
};

export default useElementDimensions;
